import { useQuery } from '@tanstack/react-query';
import type { UsersListFilters } from '../../api/strapiUsers';
import { strapiListUsers } from '../../api/strapiUsers';
import { queryKeys } from '../queryKeys';

export function useUsersQuery(jwt: string | null, filters: UsersListFilters, enabled = true) {
  return useQuery({
    queryKey: queryKeys.users(jwt, filters),
    queryFn: () => strapiListUsers(jwt!, filters),
    enabled: Boolean(jwt) && enabled,
    // User list only changes via mutations (those already invalidate `queryKeys.users`).
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
